const e = {
  "ld.startEditing": "Začít upravovat.",
  "ld.dashboard": "Moje nástěnka",
  "ld.search": "Vyhledat",
  "ld.browse": "Procházet",
  "ld.reset": "Resetovat",
  "ld.searchResource": "Vyhledávání zdrojů",
  "ld.create": "Vytvořit zdroj",
  "ld.edit": "Upravit",
  "ld.editResource": "Upravit zdroj",
  "ld.main": "Hlavní",
  "ld.and": "A",
  "ld.or": "NEBO",
  "ld.not": "NE",
  "ld.saveRd": "Uložit zdroj",
  "ld.closeRd": "Zavřít zdroj",
  "ld.deleteRd": "Smazat zdroj",
  "ld.resources": "Zdroje",
  "ld.searchBy": "Vyhledat podle",
  "ld.searchFor": "Vyhledat",
  "ld.searchAndFilter": "Vyhledat a filtrovat",
  "ld.enterSearchCriteria": "Zadejte vyhledávací kritéria pro zahájení vyhledávání",
  "ld.chooseFilterOrEnterSearchQuery": "Chcete-li zobrazit výsledky, vyberte filtr nebo zadejte vyhledávací dotaz.",
  "ld.searchNoRdsMatch": "Vašemu dotazu neodpovídají žádné popisy zdrojů",
  "ld.searchBySth": "Vyhledat podle {by}...",
  "ld.errorFetching": "Chyba při načítání dat",
  "ld.errorLoadingResource": "Chyba při načítání zdroje",
  "ld.actions": "Akce",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LCNAF",
  "ld.title": "Název",
  "ld.contributor": "Autor",
  "ld.author": "Autor",
  "ld.pubDate": "Datum publikace",
  "ld.pubDateShort": "Datum vyd.",
  "ld.edition": "Vydání",
  "ld.select": "Vybrat",
  "ld.subclass": "Podtřída",
  "ld.heading": "Nadpis",
  "ld.selectForEditing": "Vyberte popis zdroje k úpravě",
  "ld.startFromScratch": "Začít znovu od začátku",
  "ld.selectOrStartFromScratch": "{select} nebo {startFromScratch}",
  "ld.backToTop": "Zpět na začátek",
  "ld.preview": "Náhled",
  "ld.confirmCloseRd": "Opravdu chcete popis zdroje zavřít? Všechny neuložené změny budou ztraceny.",
  "ld.confirmDeleteRd": "Opravdu chcete smazat popis zdroje?",
  "ld.saveClose": "Uložit a zavřít",
  "ld.close": "Zavřít",
  "ld.delete": "Smazat",
  "ld.return": "Návrat",
  "ld.rdSaveSuccess": "Zdroj vytvořen. Očekávejte krátkou prodlevu, než se zdroj zobrazí ve FOLIO.",
  "ld.rdUpdateSuccess": "Zdroj aktualizován. Počítejte s krátkou prodlevou, než se změny projeví ve FOLIO.",
  "ld.cantSaveRd": "Nelze uložit popis zdroje",
  "ld.cantDeleteRd": "Nelze smazat popis zdroje",
  "ld.rdDeleted": "Popis zdroje byl smazán",
  "ld.appFail": "Došlo k chybě. Prosím, načtěte stránku znovu.",
  "ld.searchSelectIndex": "Vyberte prosím index",
  "ld.advancedSearch": "Rozšířené vyhledávání",
  "ld.advanced": "Pokročilé",
  "ld.cancel": "Zrušit",
  "ld.loading": "Načítání...",
  "ld.paginationCount": "{startCount} - {endCount} z {totalResultsCount}",
  "ld.yes": "Ano",
  "ld.no": "Ne",
  "ld.cantLoadSimpleLookupData": "Nelze načíst data pro jednoduché vyhledávání",
  "ld.publishDate": "Datum vydání",
  "ld.format": "Formát",
  "ld.suppressed": "Potlačeno",
  "ld.notSuppressed": "Není potlačeno",
  "ld.volume": "Svazek",
  "ld.ebook": "eKniha",
  "ld.allTime": "Po celou dobu",
  "ld.past12Months": "Posledních 12 měsíců",
  "ld.past10Yrs": "Posledních 10 let",
  "ld.past5Yrs": "Posledních 5 let",
  "ld.customRange": "Vlastní rozsah",
  "ld.all": "Všechny",
  "ld.onlineResource": "Online zdroj",
  "ld.startsWith": "Začíná na",
  "ld.containsAll": "Obsahuje vše",
  "ld.exactPhrase": "Přesná fráze",
  "ld.publisher": "Vydavatel",
  "ld.creator": "Tvůrce",
  "ld.language": "Jazyk",
  "ld.classificationNumber": "Číslo klasifikace",
  "ld.work": "Práce",
  "ld.instances": "Tituly",
  "ld.noInstancesAvailable": "Nejsou k dispozici žádné tituly.",
  "ld.noInstancesAdded": "Nebyly přidány žádné tituly",
  "ld.addAnInstance": "Přidat titul",
  "ld.type": "Typ",
  "ld.expandAll": "Rozbalit vše",
  "ld.collapseAll": "Sbalit vše",
  "ld.showAllWithCount": "Zobrazit vše ({amt})",
  "ld.showAdditionalComponents": "Zobrazit další součásti ({amt})",
  "ld.hideAdditionalComponents": "Skrýt další součásti",
  "ld.hide": "Skrýt",
  "ld.saveAndClose": "Uložit a zavřít",
  "ld.saveAndContinue": "Uložit a pokračovat",
  "ld.editInstance": "Upravit titul",
  "ld.editWork": "Upravit práci",
  "ld.createInstance": "Vytvořit titul",
  "ld.createWork": "Vytvořit dílo",
  "ld.saveAndKeepEditing": "Uložit a pokračovat v úpravách",
  "ld.recordMappingToSchema": "Na schéma nelze použít záznam",
  "ld.newResource": "Nový zdroj",
  "ld.addInstance": "Přidat titul",
  "ld.compareSelected": "Porovnat vybrané",
  "ld.newInstance": "Nový titul",
  "ld.newWork": "Nová práce",
  "ld.new": "Nový",
  "ld.cantSelectReferenceContents": "Při načítání odkazu nelze vybrat obsah odkazu",
  "ld.addNewInstance": "Přidat nový titul",
  "ld.askSaveChangesBeforeProceeding": "Chcete uložit změny, než budete pokračovat?",
  "ld.unsavedRecentEdits": "Nedávné úpravy zdroje nebyly uloženy. Neuložené změny budou ztraceny.",
  "ld.unsavedChanges": "Neuložené změny",
  "ld.continueWithoutSaving": "Pokračovat bez ukládání",
  "ld.noTitleInBrackets": "Bez názvu",
  "ld.viewMarc": "Zobrazit MARC",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "Pro tento popis zdroje nelze načíst MARC",
  "ld.duplicate": "Duplikovat",
  "ld.viewLinkedData": "Zobrazit propojená data",
  "ld.viewInInventory": "Zobrazit v aplikaci Katalog",
  "ld.authorityType": "Typ autority",
  "ld.person": "Osoba",
  "ld.source": "Zdroj",
  "ld.family": "Rodina",
  "ld.organization": "Organizace",
  "ld.meeting": "Schůzka",
  "ld.corporateBody": "Právnická osoba",
  "ld.jurisdiction": "Jurisdikce",
  "ld.conference": "Konference",
  "ld.authorizedReference": "Autorizováno/Odkaz",
  "ld.headingReference": "Nadpis/Odkaz",
  "ld.unauthorized": "Neoprávněný",
  "ld.assign": "Přiřadit",
  "ld.assignAuthority": "Přiděltit autoritu",
  "ld.change": "Změna",
  "ld.searchCreatorAuthority": "Vyhledat autoritativní záznam tvůrce",
  "ld.selectMarcAuthority": "Zvolte MARC autoritu",
  "ld.marcAuthority": "MARC autorita",
  "ld.keyword": "Klíčové slovo",
  "ld.recordsFound": "{recordsCount} nalezených záznamů",
  "ld.resourceWithIdIsEmpty": "Popis zdroje {id} je prázdný",
  "ld.duplicateInstance": "Duplicitní titul",
  "ld.duplicateWork": "Duplicitní práce",
  "ld.duplicateInstanceInBrackets": "(DUPLICITNÍ TITUL)",
  "ld.duplicateWorkInBrackets": "(DUPLICITNÍ PRÁCE)",
  "ld.identifierAll": "Identifikátor (vše)",
  "ld.personalName": "Osobní jméno",
  "ld.corporateName": "Název společnosti/konference",
  "ld.geographicName": "Zeměpisný název",
  "ld.nameTitle": "Jméno-název",
  "ld.uniformTitle": "Jednotný název",
  "ld.subject": "Předmět",
  "ld.childrensSubjectHeading": "Dětské tematické okruhy",
  "ld.genre": "Žánr",
  "ld.authoritySource": "Zdroj autority",
  "ld.references": "Odkazy",
  "ld.thesaurus": "Tezaurus",
  "ld.typeOfHeading": "Typ nadpisu",
  "ld.dateCreated": "Datum vytvoření",
  "ld.dateUpdated": "Datum aktualizace",
  "ld.excludeSeeFrom": "Vyloučit viz.",
  "ld.excludeSeeFromAlso": "Vyloučit viz. také",
  "ld.previous": "Předchozí",
  "ld.next": "Další",
  "ld.from": "Od",
  "ld.to": "Do",
  "ld.apply": "Použít",
  "ld.notSpecified": "Nespecifikováno",
  "ld.externalResourcePreview": "Náhled externího zdroje",
  "ld.errorFetchingExternalResourceForPreview": "Chyba při načítání externího zdroje pro náhled",
  "ld.fetchingExternalResourceById": "Načítání externího ID zdroje {resourceId}...",
  "ld.lastUpdated": "Poslední aktualizace",
  "ld.marcAuthorityRecord": "Záznam MARC autority",
  "ld.selectBrowseOption": "Vybrat možnost procházení",
  "ld.searchQueryWouldBeHere": "{query} by byl tady",
  "ld.continue": "Pokračovat",
  "ld.aria.filters.select": "Vybrat vyhledávací identifikátory",
  "ld.aria.filters.textbox": "Textové pole vyhledávacího dotazu",
  "ld.aria.filters.reset": "Tlačítko resetovat filtry",
  "ld.aria.filters.reset.announce": "Vyhledávací pole a filtry jsou resetovány",
  "ld.backToInventory": "Zpět do katalogu",
  "ld.properties": "Vlastnosti",
  "ld.errorFetchingExternalResourceForEditing": "Chyba při načítání externího zdroje pro úpravy",
  "ld.duplicateImportWarn": "Upozornění na duplicitní import",
  "ld.rdPropertiesMatchContinue": "Vlastnosti tohoto zdroje odpovídají existujícímu zdroji. Chcete pokračovat?",
  "ld.instance": "Titul",
  "ld.year": "Ročně",
  "ld.aria.modal.close": "Zavřít {modalKind} modálni náhled",
  "ld.aria.advancedSearch.queryInput": "Zadávání dotazů v řádcích pokročilého vyhledávání",
  "ld.aria.advancedSearch.operator": "Operátor řádku rozšířeného vyhledávání",
  "ld.aria.advancedSearch.qualifier": "Kvalifikátor řádku rozšířeného vyhledávání",
  "ld.aria.advancedSearch.identifier": "Identifikátor řádku rozšířeného vyhledávání",
  "ld.aria.listEntry.open": "Otevřít sbalitelnou položku seznamu",
  "ld.aria.listEntry.close": "Zavřete položku sbalitelného seznamu",
  "ld.aria.table.selectRow": "Vyberte řádek tabulky",
  "ld.aria.sections.openResourcePreview": "Otevřít sekci náhledu zdrojů",
  "ld.aria.sections.closeResourcePreview": "Zavřít část náhledu zdrojů",
  "ld.aria.edit.close": "Zavřít stránku úprav",
  "ld.aria.edit.deleteComponent": "Smazat komponentu",
  "ld.aria.edit.duplicateComponent": "Duplikovat komponentu",
  "ld.aria.resourcePreview.close": "Zavřít panel náhledu zdrojů",
  "ld.aria.externalResourcePreview.close": "Zavřete stránku náhledu externího zdroje",
  "ld.aria.marcAuthorityPreview.close": "Zavřít náhled autority MARC",
  "ld.aria.marcPreview.close": "Zavřít modální náhled MARC",
  "ld.aria.complexLookup.marcPreview.close": "Zavřít sekci náhledu MARC",
  "ld.aria.edit.removeComplexLookupFieldValue": "Vymazat hodnotu komlexního vyhledávacího pole",
  "ld.errorMakingApiRequest": "Chyba při API požadavku",
  "ld.compareResources": "Porovnat zdroje",
  "ld.selectedResources": "Vybrané zdroje",
  "ld.nResourcesSelected": "Vybráno {n} zdrojů",
  "ld.clearSelections": "Vymazat výběry",
  "ld.chooseTwoResourcesCompare": "Vyberte dva nebo více zdrojů k porovnání",
  "ld.chooseOneResourceCompare": "Vyberte jiný zdroj k porovnání",
  "ld.aria.comparison.close": "Zavřít sekci porovnávání",
  "ld.aria.comparison.removeEntry": "Odstranění položky pro porovnání",
  "ld.aria.searchPane.close": "Zavřít podokno vyhledávací",
  "ld.aria.searchPane.open": "Otevřít podokno vyhledávání",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Varování nekontrolovaných autorit",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `Tento popis zahrnuje jednu nebo více nekontrolovaných autorit.
 Chcete uložit změny?`,
  "ld.errorAssigningAuthority": "Chyba při přiřazování autority",
  "ld.errorAssigningAuthority.not_valid_for_target": "Vyberte prosím autoritu s typem zdroje odpovídajícím upravovanému poli autority (např. autorita LCNAF pro pole Tvůrce)",
  "ld.errorAssigningAuthority.no_lccn": "Prozatím lze přidělovat pouze autority Kongresové knihovny. Jedná se o dočasný stav, dokud nebudou podporovány další typy zdrojů.",
  "ld.errorAssigningAuthority.unsupported_marc": "Vybraná autorita není namapována na propojená data a nelze ji zatím přiřadit. Je to dočasné, protože mapování MARC probíhá.",
  "ld.required_primary_main_title": "Pro uložení přidejte hlavní název.",
  "ld.lccn_does_not_match_pattern": "Ověření vzoru LCCN povoleno: Uveďte LCCN, které odpovídá standardní struktuře.",
  "ld.lccn_not_unique": "Unikátní LCCN zapnuto: LCCN, které jste zadali, již existuje. Zadejte prosím jiné LCCN.",
  "ld.failed_dependency": "Nelze ověřit, zda LCCN je duplicitní.",
  "ld.not_found": "ID prostředku bylo změněno jiným uživatelem, zatímco jste měli tento prostředek otevřený. Obnovte prosím okno prohlížeče.",
  "ld.mapping": "Vyskytl se problém s mapováním. Nahlaste to svému týmu podpory se snímky obrazovky a podrobným popisem toho, co se stalo.",
  "ld.generic_bad_request": "Vyskytl se problém s uživatelským rozhraním. Nahlaste to svému týmu podpory se snímky obrazovky a podrobným popisem toho, co se stalo.",
  "ld.server": "Vyskytl se problém se serverem. Nahlaste to svému týmu podpory se snímky obrazovky a podrobným popisem toho, co se stalo.",
  "ld.already_exists": "Stejné ID zdroje již existuje.",
  "ld.aria.sections.editInstance": "Upravit titul: {title}"
};
export {
  e as default
};
